import { render } from "./PaisForm.vue?vue&type=template&id=599310a4&scoped=true"
import script from "./PaisForm.vue?vue&type=script&lang=js"
export * from "./PaisForm.vue?vue&type=script&lang=js"

import "./PaisForm.vue?vue&type=style&index=0&id=599310a4&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-599310a4"]])

export default __exports__